import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const festivals = [
  {
    nameEn: "Chhath Puja",
    nameHi: "छठ पूजा",
    emoji: "🌅🙏",
    gradient: "from-orange-500 to-yellow-400",
    link: "/chhath",
  },
  {
    nameEn: "Ganesh Utsav",
    nameHi: "गणेश उत्सव",
    nameMr: "गणेश उत्सव",
    emoji: "🐘🪔",
    gradient: "from-red-500 to-orange-400",
    link: "/ganeshutsav",
  },
  {
    nameEn: "Durga Puja",
    nameHi: "दुर्गा पूजा",
    nameBn: "দুর্গা পূজা",
    emoji: "🌼🕉️",
    gradient: "from-pink-500 to-red-400",
    link: "/durgapuja",
  },
  {
    nameEn: "Dandiya & Navratri",
    nameHi: "डांडिया और नवरात्रि",
    nameGu: "ડાંડીયા અને નવરાત્રી",
    nameMr: "डांडिया आणि नवरात्री",
    emoji: "💃🎶",
    gradient: "from-purple-500 to-pink-400",
    link: "/navratri",
  },
  {
    nameEn: "Ramadan",
    nameHi: "रमज़ान",
    nameAr: "رمضان",
    emoji: "🌙🤲",
    gradient: "from-green-500 to-emerald-400",
    link: "/ramadan",
  },
];

export default function FaaPHome() {
    const authState = useSelector((state) => state.authReducer || {});
    const isLoggedIn = authState?.isLoggedIn || false;
    const userName = authState?.user?.name || "User";

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("Chhath Knowledge Base");
    const [language, setLanguage] = useState("en"); // "en" or "hi"

    // Load saved language from localStorage
    useEffect(() => {
    const savedLang = localStorage.getItem("chhathLanguage") || "en";
    setLanguage(savedLang);
    setActiveTab(savedLang === "en" ? "Chhath Knowledge Base" : "छठ ज्ञान भंडार");
    }, []);

    const toggleLanguage = () => {
    const newLang = language === "en" ? "hi" : "en";
    setLanguage(newLang);
    localStorage.setItem("chhathLanguage", newLang);
    
    // Reset active tab when language changes
    setActiveTab(newLang === "en" ? "Chhath Knowledge Base" : "छठ ज्ञान भंडार");
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };
  
    return (
    <div className="min-h-screen bg-black text-white px-4 py-6">
      <header className="sticky top-0 z-50 bg-amber-950 border-b border-orange-800 px-4 py-3 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
            <div className="text-xl lg:text-2xl font-bold text-orange-400">🌍 Festival-as-a-Platform</div>
            <div className="text-[9px] lg:text-xs text-yellow-300 mt-0.5">Built with ❤️ for Communities & Culture</div>
            <div className="text-[10px] lg:text-sm text-yellow-300">Explore Festivals • Participate • Earn • Celebrate</div>
        </div>

        <div className="flex items-center gap-4">
            {isLoggedIn ? (
                <div className="hidden md:flex items-center gap-3">
                <div className="text-xs text-amber-300">{userName}</div>
                <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700 transition text-white"
                >
                    ⏻
                </button>
                </div>
            ) : (
                <button
                onClick={() => navigate("/login")}
                className="hidden md:block px-5 py-2 rounded-full border border-orange-700 text-sm text-amber-200 hover:bg-orange-900 transition"
                >
                Login
                </button>
            )}

            {/* Mobile Hamburger */}
            <button
                onClick={() => setIsMobileMenuOpen((s) => !s)}
                className="md:hidden w-9 h-9 flex items-center justify-center text-2xl text-amber-300 bg-orange-600 rounded-lg"
                aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? "✕" : "☰"}
            </button>
        </div>
      </header>

        {/* Grid */}
        <div className="min-h-[75vh] grid grid-cols-2 lg:grid-cols-3 gap-2 place-items-center">
            {festivals.map((festival, index) => (
                <div
                key={index}
                onClick={() => navigate(festival.link)}
                className={`rounded-2xl w-full p-2 h-48 flex flex-col justify-between shadow-lg cursor-pointer bg-gradient-to-br ${festival.gradient} active:scale-95 transition`}
                >
                    <div className="text-xl lg:text-3xl">{festival.emoji}</div>

                    <div className="text-lg lg:text-xl font-semibold leading-tight space-y-0.5">
                        <div>{festival.nameEn}</div>
                        {festival.nameMr && <div>{festival.nameMr}</div>}
                        {festival.nameBn && <div>{festival.nameBn}</div>}
                        {festival.nameGu && <div>{festival.nameGu}</div>}
                        {festival.nameAr && <div className="text-left text-xl lg:text-2xl" dir="rtl">{festival.nameAr}</div>}
                        <div>{festival.nameHi}</div>
                    </div>
                </div>
            ))}
        </div>

        <footer className="bg-amber-950 border-t border-orange-800 text-amber-200 py-6 mt-auto">
            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
            <div className="text-center md:text-left">© 2026 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
                <Link to="/about-us" className="text-gray-100 hover:text-orange-300 transition">About-Us</Link>
                <Link to="/privacy-policy" className="text-gray-100 hover:text-orange-300 transition">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-gray-100 hover:text-orange-300 transition">Terms of Use</Link>
                <Link to="/contact-us" className="text-gray-100 hover:text-orange-300 transition">Contact</Link>
            </div>
            </div>
        </footer>      
    </div>
  );
}